export default __webpack_public_path__ + "static/media/193.889eb9db.svg";